import AppImage from '@/components/ui/AppImage';

export interface Product {
  id: string;
  name: string;
  category: string;
  price: string;
  description: string;
  image: string;
  alt: string;
  onSale?: boolean;
}

interface ProductCardProps {
  product: Product;
  onQuickView: (product: Product) => void;
  currentLang?: 'sl' | 'en';
}

export default function ProductCard({ product, onQuickView, currentLang = 'sl' }: ProductCardProps) {
  const detailsLabel = currentLang === 'sl' ? 'Podrobnosti' : 'Details';

  return (
    <div className="group relative">
      {/* Sale Badge */}
      {product.onSale && (
        <div className="absolute top-4 right-4 z-10 bg-error text-error-foreground px-3 py-1 rounded-full text-xs font-bold uppercase tracking-widest animate-pulse-scale">
          {currentLang === 'sl' ? 'Akcija' : 'Sale'}
        </div>
      )}

      {/* Product Image */}
      <div className="aspect-[4/5] card-rounded overflow-hidden bg-muted mb-4">
        <AppImage
          src={product.image}
          alt={product.alt}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
      </div>

      {/* Product Info */}
      <div className="space-y-2">
        <h3 className="text-xl font-bold">{product.name}</h3>
        <p className="text-sm text-muted-foreground">{product.description}</p>
        <div className="flex items-center justify-between pt-2">
          <span className="text-2xl font-bold text-primary">{product.price}</span>
          <button
            onClick={() => onQuickView(product)}
            className="text-sm font-bold text-foreground hover:text-primary transition-colors"
          >
            {detailsLabel} →
          </button>
        </div>
      </div>
    </div>
  );
}